export const findFirstAvailableMarket = (markets, ids) => {
    let market, len = ids.length;
    for (let i = 0; i < len; i += 1) {
        market = markets.find(m => {
            return m.marketType.id === ids[i];
        });
        if (market) {
            break;
        }
    }
    return market;
};
//# sourceMappingURL=findFirstAvailableMarket.js.map